<template>
  <v-container class="web-camera-container" :style="'width: ' + cameraWidth + 'px'">
    <!-- <div class="dialog-container"> -->

    <!-- <v-dialog :width="cameraWidth + 'px'" :persistent="false" v-model="dialog"> -->

    <div class="camera-dialog pa-2">
      <div v-if="isCameraOpen" class="mt-2 ml-2" v-show="!isLoading">
        <!-- <v-card>
          <v-card-title></v-card-title> -->
        <video :width="cameraWidth - 50" ref="camera" autoplay></video>

        <!-- </v-card> -->

        <canvas
          v-show="isPhotoTaken"
          id="photoTaken"
          ref="canvas"
          :width="cameraWidth"
          :height="cameraHeight"
        ></canvas>
      </div>
      <v-toolbar flat>
        <v-btn class="ma-2" icon @click="toggleCamera">
          <v-icon v-if="!isCameraOpen" large>mdi-camera</v-icon>
          <v-icon v-else large>mdi-camera-off</v-icon>
        </v-btn>

        <v-spacer />
        <v-btn
          class="ma-2"
          v-if="isCameraOpen"
          :loading="isLoading"
          color="success"
          icon
          @click="takePhoto"
        >
          <v-icon large>mdi-camera-iris</v-icon>
        </v-btn>
      </v-toolbar>

      <!-- <v-expansion-panels accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>All Photos</v-expansion-panel-header>
          <v-expansion-panel-content> -->
      <!-- <v-icon v-if="!images.length">mdi-image-off</v-icon> -->
      <span v-if="!images.length && !isCameraOpen">No Images</span>

      <v-carousel v-if="images.length && !isCameraOpen && !isLoading" id="myImages">
        <v-carousel-item v-for="(img, i) in images" :key="i" :src="img">
          <v-btn icon small @click.stop="deleteImage(i)" class="delete-button">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-carousel-item>
      </v-carousel>

      <!-- </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels> -->
    </div>
    <!-- </v-dialog> -->
    <!-- </div> -->
    <!-- <v-btn class="ma-2" color="success" icon @click="toggleCamera">
      <v-icon large>mdi-camera</v-icon>
    </v-btn> -->
  </v-container>
</template>

<script>
import Vue from "vue";
import VueAxios from "vue-axios";
import axios from "axios";
Vue.use(VueAxios, axios);
export default {
  name: "TakePhoto",
  components: {},
  props: {
    objectName: String,
    recordId: String,
    portal: String,
    filename: String,
    photoName: String,
    childObject: String,
    cameraWidth: Number,
    cameraHeight: Number,
    formModel: Object,
  },
  data() {
    return {
      test: false,
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
      link: "#",

      images: [],
      fileLength: 0,
      dialog: false,
      myPortal: "",
      myObjectName: "",
      myRecordeId: "",
      myChildObject: "",
      myFileName: "",
      myPhotoName: "",
    };
  },
  mounted() {
    var that = this;
    this.myPortal = this.portal;
    this.myObjectName = this.objectName;
    this.myRecordeId = this.recordId;
    this.myChildObject = this.childObject;
    this.myFileName = this.filename;
    this.myPhotoName = this.photoName;
    // this.$root.$on("openCamera", (obj) => {
    //   console.log(obj);
    //   that.myPortal = "portal_" + this.$root.portal_id;
    //   that.myObjectName = "shipment";
    //   that.myRecordId = obj.obj.parentObject._id;
    //   that.myChildObject = "inventory\\" + obj.item._id;
    //   that.myFileName =
    //     obj.item.item +
    //     "_" +
    //     parseInt(Math.random() * 1000).toString() +
    //     "_" +
    //     obj.item._id;
    //   that.myPhotoName = that.myFileName;
    //   that.getFiles({
    //     portal: that.myPortal,
    //     object_name: that.myObjectName,
    //     record_id: that.myRecordId,
    //     child_object: that.myChildObject,
    //   });
    if (this.recordId) {
      // that.toggleCamera();
      // that.isCameraOpen = true;
    }

    // });
    this.getFiles({
      portal: this.objectName,
      object_name: this.objectName,
      record_id: this.recordId,
      child_object: this.childObject,
    });
  },
  beforeDestroy() {
    // this.toggleCamera();
  },
  methods: {
    deleteImage(index) {
      var that = this;
      var file = this.images[index];

      var data = {
        file_path: file,
      };
      this.$root.$confirm
        .open("Delete", "Confirm deleting file?", {
          color: "red",
        })
        .then((confirm) => {
          if (confirm) {
            // if (!isDropBox) {
            axios
              .post(this.serverURL + "/delete_file", data, {
                withCredentials: true,
              })
              .then((response) => {
                // this.getFiles(data);
                this.images.splice(index, 1);
              });
            // } else {
            //   var dFiles = that.dropBoxFiles.find((b) => {
            //     return b.title == fileName;
            //   });

            //   dFiles.chunks.forEach((d) => {
            //     // var myFile = that.files.find((f) => {
            //     //   return f.name == d.path;
            //     // });
            //     this.par.model.dropbox_files = this.par.model.dropbox_files.filter(
            //       (f) => {
            //         return f != d.path;
            //       }
            //     );
            //     that.dropBoxFiles = that.dropBoxFiles.filter((f) => {
            //       return f.title != fileName;
            //     });

            //     this.getFromDropBox(d.path, true);
            //   });
            // }
            // try {
            //   this.par.submit(false, false);
            // } catch (error) {
            //   //
            // }
          }
        });
    },

    getFiles(data) {
      this.files = [];
      this.images = [];
      var that = this;
      axios
        .post(this.serverURL + "/get_files", data, {
          withCredentials: true,
        })
        .then((response) => {
          var allFiles = response.data;
          if (that.formModel) {
            that.formModel.images = allFiles.length;
          }

          if (allFiles) {
            this.fileLength = allFiles.length;
            var path =
              "user_images/" +
              this.myPortal +
              "/" +
              data.object_name +
              "/" +
              data.record_id +
              "/" +
              data.child_object +
              "/";
            allFiles.forEach((f) => {
              // var included = true;
              // if (this.filter) {
              //   included = this.checkFilter(f);
              // }
              // if (included) {
              // if (f.split(".").length > 1) {
              // if (that.imgExt.includes(f.split(".")[1].toLowerCase())) {

              that.images.push(path + f);
              // } else {
              //   that.files.push(f);
              // }
              // }
              // }
            });
            // that.mainImage = that.images.length ? that.images[0] : "";
            // if (that.vModel) {
            //   if (that.images.includes(that.vModel)) {
            //     that.mainImage = that.vModel;
            //   }
            // }
            // this.docs = 1;
          }
        });
    },
    finish() {
      this.$emit("input", this.images);
      this.$root.$emit("imageFinish", this.images);
    },
    toggleCamera() {
      if (this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
        this.dialog = false;
      } else {
        this.dialog = true;
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },

    createCameraElement() {
      this.isLoading = true;

      const constraints = (window.constraints = {
        audio: false,
        video: {
          facingMode: "environment",
        },
      });

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.isLoading = false;
          this.$refs.camera.srcObject = stream;
        })
        .catch((error) => {
          this.isLoading = false;
          // alert("May the browser didn't support or there is some errors.");
        });
    },

    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();

      tracks.forEach((track) => {
        track.stop();
      });
    },

    getImageDataURL(url) {
      var ctx;
      var img = new Image();
      var that = this;

      img.onload = function () {
        ctx = that.canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
      };

      try {
        img.src = url;
      } catch (e) {
        //
      }
    },
    dataURLToBlob(dataURL) {
      const parts = dataURL.split("base64,");
      const contentType = parts[0].split(":")[1];
      const raw = window.atob(parts[1]);
      const rawLength = raw.length;
      const uInt8Array = new Uint8Array(rawLength);

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }

      return new Blob([uInt8Array], { type: contentType });
    },
    upload(dataURL) {
      const blob = this.dataURLToBlob(dataURL);
      const url = window.URL.createObjectURL(blob);
      // var photoName = prompt("Please name this picture");
      var imgCnt = this.images.length + 1;
      var photoName = this.myFileName + "_" + imgCnt + ".jpg";
      if (!photoName) {
        return;
      }

      var fd = {
        file: dataURL,
        object_name: this.objectName,
        record_id: this.recordId,
        portal: this.myPortal,
        filename: photoName.replaceAll(" ", "_"),
        child_object: this.childObject,
      };

      this.isLoading = true;
      this.$nextTick(() => {
        axios.post(this.serverURL + "/upload_file", fd).then((response) => {
          var childObject = this.myChildObject ? "/" + this.myChildObject : "";
          var imageUrl =
            "/user_images/" +
            this.myPortal +
            "/" +
            this.myObjectName +
            "/" +
            this.myRecordId +
            childObject +
            "/" +
            fd.filename;
          // this.$emit("input", imageUrl);
          this.isPhotoTaken = false;
          this.images.push(imageUrl);
          this.getFiles({
            portal: this.objectName,
            object_name: this.objectName,
            record_id: this.recordId,
            child_object: this.childObject,
          });
          this.isLoading = false;
          return false;
        });
      });
    },
    takePhoto() {
      if (!this.isPhotoTaken) {
        //   this.isShotPhoto = true;
        //   const FLASH_TIMEOUT = 50;
        //   setTimeout(() => {
        //     this.isShotPhoto = false;
        //   }, FLASH_TIMEOUT);
      }

      // this.isPhotoTaken = !this.isPhotoTaken;

      const context = this.$refs.canvas.getContext("2d");
      const videoElement = this.$refs.camera;
      const canvasElement = this.$refs.canvas;
      canvasElement.width = videoElement.videoWidth;
      canvasElement.height = videoElement.videoHeight;
      // context.drawImage(this.$refs.camera, 0, 0, 450, 337.5);
      context.drawImage(videoElement, 0, 0, canvasElement.width, canvasElement.height);
      this.toggleCamera();
      this.downloadImage();
      this.isLoading = false;
    },

    downloadImage() {
      const download = document.getElementById("downloadPhoto");
      const dataURL = document
        .getElementById("photoTaken")
        .toDataURL("image/jpeg")
        .replace("image/jpeg", "image/octet-stream");

      // const dataURL = canvas.toDataURL();
      this.upload(dataURL);
    },
  },
};
</script>

<style lang="css" scoped>
.web-camera-container {
  /* position: fixed;
  width: 500px;
  background-color: white; */

  /* z-index: 100; */
}
.camera-dialog {
  background-color: white;
}
.dialog-container {
  position: fixed; /* Fixed positioning relative to the viewport */
  top: 50%; /* Center vertically */
  left: 50%; /* Center horizontally */
  transform: translate(-50%, -50%); /* Adjust to truly center the element */
  /* Ensure the container is large enough or set width/height as needed */
}
@media only screen and (max-width: 450px) {
  .web-camera-containe- {
    width: 100%;
    height: 100%;
    /* z-index: 100; */
    position: absolute;
    top: 0;
    left: 0;
    background-color: white;
  }
  .camera-toolbar {
    position: fixed;
    /* background-color: green; */
    bottom: 0;
    width: 100%;
  }
  .my-images {
    max-height: 110px;
    overflow: auto;
  }
  .camera-box {
    position: fixed;
    bottom: 0;
  }
}
</style>
